import { Box, Grid, Tab, Tabs } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

// import AppliedCandidate from "./AppliedCandidate";
import ResaleEquipmentg from "./ResaleEquipment";
import AppliedCandidate from "../Jobhiringpost/AppliedCandidate";
import Enquiries from "../myInstitute/enquiries";
import AddResaleFurnature from "./AddDetails";
// import InstituteInformation from "./instituteInformation";
// import Course from "./Course";
// import Enquiries from "./appliedCandidate";

export const ResaleFurnature = ({}) => {
  const [value, setValue] = React.useState("all");
  const [open, setOpen] = React.useState(null);
  const [ModalData, SetModalData] = React.useState("all");

  const [appliedCandidate, setAppliedCandidate] = React.useState(null);
  const handleChange = (event, newValue) => {
    // setPageNo(1);

    setValue(newValue);
  };
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab,
  );

  return (
    <Box>
      <Grid container>
        <Grid item xs={12}>
          {/* {(!businessChooseTab || businessChooseTab?.value == "resaEqu") && (
            <ResaleEquipmentg />
          )} */}
          {/* {(!businessChooseTab || businessChooseTab?.value == "posts") && (
            <Posts />
          )} */}

          {/* {businessChooseTab?.value == "posts" && ( */}
          <>
            {/* {!appliedCandidate && (
              <ResaleEquipmentg
                SetModalData={(data) => {
                  SetModalData(data);
                }}
                setOpen={setOpen}
                clickappliedCandidate={(da) => {
                  setAppliedCandidate(da);
                }}
              />
            )} */}

            {appliedCandidate ? (
              <Enquiries
                Resale={true}
                enquiries={appliedCandidate}
                backEnquire={() => {
                  setAppliedCandidate(null);
                }}
              />
            ) : open ? (
              <AddResaleFurnature
                open={open}
                ModalData={ModalData}
                setOpen={setOpen}
              />
            ) : (
              <ResaleEquipmentg
                SetModalData={(data) => {
                  SetModalData(data);
                }}
                setOpen={setOpen}
                clickappliedCandidate={(da) => {
                  setAppliedCandidate(da);
                }}
              />
            )}
            {/* {appliedCandidate && (
              <Enquiries
                Resale={true}
                enquiries={appliedCandidate}
                backEnquire={() => {
                  setAppliedCandidate(null);
                }}
              />
            )}

            {open && (
              <AddResaleFurnature
                open={open}
                ModalData={ModalData}
                setOpen={setOpen}
              />
            )} */}
          </>
          {/* )} */}
        </Grid>
      </Grid>
    </Box>
  );
};
